import { memo } from "react";
import { IconProps, defaultIconProps } from "./icon.props.type";
import Theme from "@/utils/theme";

const InfoIcon = ({
  color = Theme.colors.feedback.info,
  size = defaultIconProps.size,
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke={color} />
      <g clip-path="url(#clip0_306_7627)">
        <path
          d="M11.2 14.8C11.2 14.9061 11.1579 15.0078 11.0828 15.0828C11.0078 15.1579 10.9061 15.2 10.8 15.2C10.4817 15.2 10.1765 15.0736 9.95147 14.8485C9.72643 14.6235 9.6 14.3183 9.6 14V10C9.6 9.89391 9.55786 9.79217 9.48285 9.71715C9.40783 9.64214 9.30609 9.6 9.2 9.6C9.09392 9.6 8.99217 9.55786 8.91716 9.48284C8.84214 9.40783 8.8 9.30608 8.8 9.2C8.8 9.09391 8.84214 8.99217 8.91716 8.91716C8.99217 8.84214 9.09392 8.8 9.2 8.8C9.51826 8.8 9.82349 8.92643 10.0485 9.15147C10.2736 9.37651 10.4 9.68174 10.4 10V14C10.4 14.1061 10.4421 14.2078 10.5172 14.2828C10.5922 14.3579 10.6939 14.4 10.8 14.4C10.9061 14.4 11.0078 14.4421 11.0828 14.5172C11.1579 14.5922 11.2 14.6939 11.2 14.8ZM9.6 6.4C9.75823 6.4 9.9129 6.35308 10.0445 6.26517C10.176 6.17727 10.2786 6.05233 10.3391 5.90615C10.3997 5.75996 10.4155 5.59911 10.3846 5.44393C10.3538 5.28874 10.2776 5.1462 10.1657 5.03431C10.0538 4.92243 9.91126 4.84624 9.75607 4.81537C9.60089 4.7845 9.44004 4.80035 9.29386 4.8609C9.14767 4.92145 9.02273 5.02398 8.93483 5.15554C8.84692 5.2871 8.8 5.44177 8.8 5.6C8.8 5.81217 8.88429 6.01566 9.03432 6.16568C9.18435 6.31571 9.38783 6.4 9.6 6.4ZM20 10C20 11.9778 19.4135 13.9112 18.3147 15.5557C17.2159 17.2002 15.6541 18.4819 13.8268 19.2388C11.9996 19.9957 9.98891 20.1937 8.0491 19.8078C6.10929 19.422 4.32746 18.4696 2.92894 17.0711C1.53041 15.6725 0.578004 13.8907 0.192152 11.9509C-0.1937 10.0111 0.00433268 8.00043 0.761209 6.17316C1.51809 4.3459 2.79981 2.78412 4.4443 1.6853C6.08879 0.58649 8.02219 0 10 0C12.6513 0.0029116 15.1931 1.05741 17.0679 2.93215C18.9426 4.80688 19.9971 7.34873 20 10ZM19.2 10C19.2 8.18041 18.6604 6.40168 17.6495 4.88875C16.6386 3.37582 15.2018 2.19663 13.5207 1.50031C11.8396 0.803982 9.9898 0.621791 8.20517 0.976775C6.42055 1.33176 4.78126 2.20797 3.49462 3.49462C2.20798 4.78126 1.33176 6.42054 0.97678 8.20517C0.621796 9.98979 0.803986 11.8396 1.50031 13.5207C2.19664 15.2018 3.37583 16.6386 4.88876 17.6495C6.40169 18.6604 8.18042 19.2 10 19.2C12.4392 19.1973 14.7777 18.2272 16.5025 16.5025C18.2272 14.7777 19.1974 12.4392 19.2 10Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_306_7627">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(InfoIcon);
